import React from 'react';
import { useLang } from '../context/LanguageContext';
import { PageHeader } from '../components/PageHeader';
import ContactStrip from '../components/ContactStrip';
import LegalBody from '../components/LegalBody';
import SEO from '../components/SEO';
import { getSeo, SEO_KEYWORDS } from '../data/seo';
import { IMPRINT } from '../data/legal';

// Legal notice / Impressum — final client-provided version (DE + official EN).
const Impressum = () => {
  const { lang } = useLang();
  const seo = getSeo('impressum', lang);
  return (
    <div>
      <SEO title={seo.title} description={seo.description} path="/impressum" lang={lang} keywords={SEO_KEYWORDS[lang]} />
      <PageHeader label={lang === 'de' ? 'Impressum' : 'Legal Notice'} title={lang === 'de' ? 'Impressum' : 'Legal Notice'} />
      <section className="bg-white py-16 lg:py-24">
        <div className="container-wide max-w-3xl" data-testid="impressum-content">
          <LegalBody blocks={lang === 'de' ? IMPRINT.de : IMPRINT.en} />
        </div>
      </section>
      <ContactStrip />
    </div>
  );
};

export default Impressum;
